module.exports = __webpack_public_path__ + "static/media/angryBagel.ea50265c.svg";